import React, { useMemo } from 'react'
import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, ApolloProvider } from '@apollo/client'

import useConfig from '@/gf/hooks/useConfig'
import { createTraceContextLink } from '@/gf/utils/apolloTraceLink'
import Money from '@/gf/modules/Money'

const GqlClientProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const config = useConfig()

  const client = useMemo(
    () =>
      new ApolloClient({
        link: ApolloLink.from([
          createTraceContextLink(),
          new HttpLink({ uri: `${config.gfBaseUrl}/gql` }),
        ]),
        cache: new InMemoryCache({
          typePolicies: {
            Product: {
              fields: {
                salePrice: {
                  read: Money.fromPayload,
                },
                shippingCost: {
                  read: Money.fromPayload,
                },
              },
            },
            SourceProduct: {
              fields: {
                listPrice: {
                  read: Money.fromPayload,
                },
                shippingCost: {
                  read: Money.fromPayload,
                },
              },
            },
          },
        }),
        credentials: 'include',
        defaultOptions: { query: { fetchPolicy: 'no-cache' } },
      }),
    [config.gfBaseUrl]
  )

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default GqlClientProvider
